import { render, staticRenderFns } from "./guangdong.vue?vue&type=template&id=f89ccdec&scoped=true&"
import script from "./guangdong.vue?vue&type=script&lang=js&"
export * from "./guangdong.vue?vue&type=script&lang=js&"
import style0 from "./guangdong.vue?vue&type=style&index=0&id=f89ccdec&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89ccdec",
  null
  
)

export default component.exports